import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" To List of Intertexts for this Verse ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionHeader = _resolveComponent("SectionHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SectionHeader, {
      infoText: _ctx.intertextWeb.payload?.introduction_general
    }, {
      title: _withCtx(() => [
        _createElementVNode("span", {
          innerHTML: _ctx.$t('intertext.title') + ' <small>' + _ctx.$t('global.sura') + ' '
+ _ctx.$route.params.sura  + ' ' + _ctx.$t('global.verse') + ' ' +
_ctx.$route.params.verse + '</small>'
        }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["infoText"]),
    (_ctx.$route.name === 'VerseIntertextDetail')
      ? (_openBlock(), _createBlock(_component_PrimaryButton, {
          key: 0,
          class: "text-black w-72 my-5 ml-auto"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'VerseIntertextResults' },
              class: "grid place-content-center text-black h-full w-full"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view)
  ], 64))
}